"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskRunnerException = void 0;
var TaskRunnerException;
(function (TaskRunnerException) {
    TaskRunnerException["BatchedIngestProcessingStalled"] = "BatchedIngestProcessingStalled";
})(TaskRunnerException = exports.TaskRunnerException || (exports.TaskRunnerException = {}));
//# sourceMappingURL=task-runner-error-codes.js.map